import { buildEndpointUrl } from '@/_shared/helpers/makeSwaggerToEndpointUrl';
import { payloadToQueryParamsUrl } from '@/_shared/helpers/payloadToQueryParamsUrl';
import { GenericGet } from '@/_shared/types';
import {
  API_EMPLOYEES_IMPORTS_TEMPLATE_PATH_KEY,
  API_ORGANIZATIONS_ORGANIZATIONID_EMPLOYEES_EMPLOYEEID_PATH_KEY,
  API_ORGANIZATIONS_ORGANIZATIONID_EMPLOYEES_IMPORTS_FILE_PATH_KEY,
  API_ORGANIZATIONS_ORGANIZATIONID_EMPLOYEES_IMPORTS_JOBID_PATH_KEY,
  API_ORGANIZATIONS_ORGANIZATIONID_EMPLOYEES_IMPORTS_JOBID_RECORDS_PATH_KEY,
  API_ORGANIZATIONS_ORGANIZATIONID_EMPLOYEES_IMPORTS_JOBID_RECORDS_RECORDID_PATH_KEY,
  API_ORGANIZATIONS_ORGANIZATIONID_EMPLOYEES_PATH_KEY,
  API_ORGANIZATIONS_ORGANIZATIONID_EMPLOYEES_STATS_PATH_KEY,
  API_ORGANIZATIONS_ORGANIZATIONID_EMPLOYEES_IMPORTS_JOBID_RECORDS_STATS_PATH_KEY,
  API_ORGANIZATIONS_ORGANIZATIONID_EMPLOYEES_IMPORTS_JOBID_RECORDS_COMMIT_PATH_KEY,
  API_ORGANIZATIONS_ORGANIZATIONID_EMPLOYEES_FILTERS_PATH_KEY,
  API_ORGANIZATIONS_ORGANIZATIONID_EMPLOYEES_EMPLOYEEID_ACCOUNT_ENABLE_PATH_KEY,
  API_ORGANIZATIONS_ORGANIZATIONID_EMPLOYEES_EMPLOYEEID_ACCOUNT_DISABLE_PATH_KEY,
  API_ORGANIZATIONS_ORGANIZATIONID_EMPLOYEES_IMPORTS_OVERVIEW_PATH_KEY,
  API_ORGANIZATIONS_ORGANIZATIONID_EMPLOYEES_IMPORTS_JOBID_RECORDS_ABORT_PATH_KEY,
  API_ORGANIZATIONS_ORGANIZATIONID_EMPLOYEES_IMPORTS_JOBID_ABORT_PATH_KEY,
  API_ORGANIZATIONS_ORGANIZATIONID_EMPLOYEES_DELETE_CHECK_PATH_KEY,
  API_ORGANIZATIONS_ORGANIZATIONID_EMPLOYEES_EMAIL_ALREADY_EXIST_PATH_KEY,
} from '@/swagger/constants/anagraphics-keys';
import { FiltersEmployees } from '../types/filtersEmployees';

type EmployeesImportQueryParams = GenericGet<
  typeof API_ORGANIZATIONS_ORGANIZATIONID_EMPLOYEES_IMPORTS_JOBID_RECORDS_PATH_KEY
>['request']['query'];

export const API_GET_DOWNLOAD_EMPLOYEES_IMPORTS_TEMPLATE = () => {
  return buildEndpointUrl(API_EMPLOYEES_IMPORTS_TEMPLATE_PATH_KEY, {});
};

export const API_POST_EMPLOYEES_IMPORTS_TEMPLATE = (organizationId: string) => {
  return buildEndpointUrl(API_ORGANIZATIONS_ORGANIZATIONID_EMPLOYEES_IMPORTS_FILE_PATH_KEY, {
    organizationId,
  });
};

export const API_GET_EMPLOYEES_IMPORTS_BY_JOB_ID = (organizationId: string, jobId: string) => {
  return buildEndpointUrl(API_ORGANIZATIONS_ORGANIZATIONID_EMPLOYEES_IMPORTS_JOBID_PATH_KEY, {
    organizationId,
    jobId,
  });
};

export const API_GET_EMPLOYEES_IMPORT = (
  organizationId: string,
  jobId: string,
  queryParams: EmployeesImportQueryParams,
) => {
  const baseUrl = buildEndpointUrl(
    API_ORGANIZATIONS_ORGANIZATIONID_EMPLOYEES_IMPORTS_JOBID_RECORDS_PATH_KEY,
    {
      organizationId,
      jobId,
    },
  );
  return payloadToQueryParamsUrl(queryParams, baseUrl);
};

export const API_PUT_EMPLOYEES_IMPORT = (
  organizationId: string,
  jobId: string,
  recordId: string,
) => {
  return buildEndpointUrl(
    API_ORGANIZATIONS_ORGANIZATIONID_EMPLOYEES_IMPORTS_JOBID_RECORDS_RECORDID_PATH_KEY,
    {
      organizationId,
      jobId,
      recordId,
    },
  );
};

export const API_POST_EMPLOYEES_IMPORTS_CONFIRM = (organizationId: string, jobId: string) => {
  return buildEndpointUrl(
    API_ORGANIZATIONS_ORGANIZATIONID_EMPLOYEES_IMPORTS_JOBID_RECORDS_COMMIT_PATH_KEY,
    {
      organizationId,
      jobId,
    },
  );
};

export const API_POST_EMPLOYEES_IMPORTS_ABORT = (organizationId: string, jobId: string) => {
  return buildEndpointUrl(
    API_ORGANIZATIONS_ORGANIZATIONID_EMPLOYEES_IMPORTS_JOBID_RECORDS_ABORT_PATH_KEY,
    {
      organizationId,
      jobId,
    },
  );
};

export const API_GET_EMPLOYEES = (organizationId: string, queryParams: FiltersEmployees) => {
  const baseUrl = buildEndpointUrl(API_ORGANIZATIONS_ORGANIZATIONID_EMPLOYEES_PATH_KEY, {
    organizationId,
  });
  return payloadToQueryParamsUrl(queryParams, baseUrl);
};

export const API_GET_EMPLOYEES_STATS = (organizationId: string) => {
  return buildEndpointUrl(API_ORGANIZATIONS_ORGANIZATIONID_EMPLOYEES_STATS_PATH_KEY, {
    organizationId,
  });
};

export const API_GET_EMPLOYEES_IMPORTS_STATS = (organizationId: string, jobId: string) => {
  return buildEndpointUrl(
    API_ORGANIZATIONS_ORGANIZATIONID_EMPLOYEES_IMPORTS_JOBID_RECORDS_STATS_PATH_KEY,
    {
      organizationId,
      jobId,
    },
  );
};

export const API_GET_EMPLOYER_BY_ID = (organizationId: string, employeeId: string) => {
  return buildEndpointUrl(API_ORGANIZATIONS_ORGANIZATIONID_EMPLOYEES_EMPLOYEEID_PATH_KEY, {
    organizationId,
    employeeId,
  });
};

export const API_PUT_EMPLOYER_BY_ID = (organizationId: string, employeeId: string) => {
  return buildEndpointUrl(API_ORGANIZATIONS_ORGANIZATIONID_EMPLOYEES_EMPLOYEEID_PATH_KEY, {
    organizationId,
    employeeId,
  });
};

export const API_DELETE_EMPLOYER_BY_ID = (organizationId: string, employeeId: string) => {
  return buildEndpointUrl(API_ORGANIZATIONS_ORGANIZATIONID_EMPLOYEES_EMPLOYEEID_PATH_KEY, {
    organizationId,
    employeeId,
  });
};

export const API_GET_EMPLOYEES_FILTERS = (organizationId: string) => {
  return buildEndpointUrl(API_ORGANIZATIONS_ORGANIZATIONID_EMPLOYEES_FILTERS_PATH_KEY, {
    organizationId,
  });
};

export const API_POST_EMPLOYER_BY_ID_ENABLE = (organizationId: string, employeeId: string) => {
  return buildEndpointUrl(
    API_ORGANIZATIONS_ORGANIZATIONID_EMPLOYEES_EMPLOYEEID_ACCOUNT_ENABLE_PATH_KEY,
    {
      organizationId,
      employeeId,
    },
  );
};

export const API_POST_EMPLOYER_BY_ID_DISABLE = (organizationId: string, employeeId: string) => {
  return buildEndpointUrl(
    API_ORGANIZATIONS_ORGANIZATIONID_EMPLOYEES_EMPLOYEEID_ACCOUNT_DISABLE_PATH_KEY,
    {
      organizationId,
      employeeId,
    },
  );
};

export const API_GET_EMPLOYEES_IMPORTS_OVERVIEW = (organizationId: string) => {
  return buildEndpointUrl(API_ORGANIZATIONS_ORGANIZATIONID_EMPLOYEES_IMPORTS_OVERVIEW_PATH_KEY, {
    organizationId,
  });
};

export const API_POST_EMPLOYEES_IMPORTS_ABORT_BY_JOB_ID = (
  organizationId: string,
  jobId: string,
) => {
  return buildEndpointUrl(API_ORGANIZATIONS_ORGANIZATIONID_EMPLOYEES_IMPORTS_JOBID_ABORT_PATH_KEY, {
    organizationId,
    jobId,
  });
};

export const API_POST_EMPLOYEES_DELETE_CHECK = (organizationId: string) => {
  return buildEndpointUrl(API_ORGANIZATIONS_ORGANIZATIONID_EMPLOYEES_DELETE_CHECK_PATH_KEY, {
    organizationId,
  });
};

export const API_POST_EMPLOYEE = (organizationId: string) => {
  return buildEndpointUrl(API_ORGANIZATIONS_ORGANIZATIONID_EMPLOYEES_PATH_KEY, {
    organizationId,
  });
};

export const API_POST_EMAIL_ALREADY_EXIST = (organizationId: string) => {
  return buildEndpointUrl(API_ORGANIZATIONS_ORGANIZATIONID_EMPLOYEES_EMAIL_ALREADY_EXIST_PATH_KEY, {
    organizationId,
  });
};
